import React, { useEffect, useState, useContext } from 'react';
import UserContext from '../context/UserContext';
import { api } from '../utils/apiHelper';
import '../styles/CreateBid.css';

const CreateBid = () => {
  const { authUser } = useContext(UserContext);
  const [items, setItems] = useState([
    { title: '', description: '', price: '', shortCode: generateShortCode(), files: [] },
  ]);
  const [successMessage, setSuccessMessage] = useState('');
  const [uploading, setUploading] = useState(false);

  function generateShortCode() {
    return Math.random().toString(36).substring(2, 8).toUpperCase();
  }

  const handleChange = (index, field, value) => {
    const updated = [...items];
    updated[index][field] = value;
    setItems(updated);
  };

  const handleFileChange = (index, e) => {
    const updated = [...items];
    updated[index].files = [...e.target.files];
    setItems(updated);
  };

  const uploadFileToS3 = async (file, shortCode) => {
    const s3Req = {
      fileName: file.name,
      fileType: file.type,
      accessType: 'public-read',
      userId: authUser._id,
      projectId: shortCode,
    };

    const s3Res = await api('/s3-url', 'POST', s3Req);
    if (!s3Res?.url || !s3Res?.key) throw new Error('S3 URL generation failed');

    await fetch(s3Res.url, {
      method: 'PUT',
      headers: { 'Content-Type': file.type },
      body: file,
    });

    return {
      key: s3Res.key,
      fileName: file.name,
      type: file.type,
    };
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    setUploading(true);

    // build items payload with uploaded file keys
    const itemsPayload = [];
    for (const item of items) {
      const { title, price, files, shortCode } = item;

      if (!title || price == null || files.length === 0) {
        alert('Each item must have a title, price, and at least one file.');
        continue;
      }

      const fileKeys = [];
      for (const file of files) {
        const meta = await uploadFileToS3(file, shortCode);
        fileKeys.push(meta);
      }

      itemsPayload.push({
        title: item.title,
        description: item.description || '',
        price: Number(item.price),
        shortCode,
        fileKeys,
      });
    }

    if (itemsPayload.length === 0) {
      alert('No valid items to submit.');
      return;
    }

    // ✅ single call that matches your backend
    await api('/create-bid-item', 'POST', {
      userId: authUser._id,
      items: itemsPayload,
    });

    setSuccessMessage('All bid items created!');
    setItems([{ title: '', description: '', price: '', shortCode: generateShortCode(), files: [] }]);
  } catch (err) {
    console.error('Error submitting items:', err.message);
  } finally {
    setUploading(false);
  }
};

  const addItem = () => {
    setItems([...items, { title: '', description: '', price: '', shortCode: generateShortCode(), files: [] }]);
  };

  if (authUser?.email !== 'support@editfarmer.com') return null;

  return (
    <div className="create-bid-container">
      <h2>Create Bid Items</h2>
      {successMessage && <p className="success-message">{successMessage}</p>}
      <form onSubmit={handleSubmit}>
        {items.map((item, index) => (
          <div key={index} className="bid-item-block">
            <label>Title*</label>
            <input type="text" value={item.title} onChange={(e) => handleChange(index, 'title', e.target.value)} required />

            <label>Description</label>
            <textarea value={item.description} onChange={(e) => handleChange(index, 'description', e.target.value)} />

            <label>Price ($)*</label>
            <input type="number" value={item.price} onChange={(e) => handleChange(index, 'price', e.target.value)} required />

            <label>Upload Files*</label>
            <input type="file" multiple onChange={(e) => handleFileChange(index, e)} required />

            <label>Short Code</label>
            <div className="code-preview">{item.shortCode}</div>

            <hr />
          </div>
        ))}

        <button type="button" onClick={addItem}>+ Add Another Item</button>
        <button type="submit" disabled={uploading}>
          {uploading ? 'Uploading...' : 'Submit All Items'}
        </button>
      </form>
    </div>
  );
};

export default CreateBid;
